const currencyTypes = {
    CHANGE_CURRENCY_START: 'CHANGE_CURRENCY_START'
};

export default currencyTypes;